
export const sleepQuestions = [
  {
    id: "difficultyWakingUp",
    question: "I have difficulties waking up in the morning."
  },
  {
    id: "notWellRested",
    question: "I do not feel well-rested upon waking."
  },
  {
    id: "exhaustedWhenWaking",
    question: "I feel exhausted when waking."
  },
  {
    id: "difficultyFallingAsleep",
    question: "I have difficulties falling asleep."
  },
  {
    id: "wakeUpTooEarly",
    question: "I wake up too early and am unable to fall asleep again."
  },
  {
    id: "wakeUpSeveralTimes",
    question: "I wake up several times at night and cannot fall asleep again."
  },
  {
    id: "poorSleep",
    question: "My sleep is poor and disturbed."
  }
];

export const sleepAssessmentSchema = {
  difficultyWakingUp: "",
  notWellRested: "",
  exhaustedWhenWaking: "",
  difficultyFallingAsleep: "",
  wakeUpTooEarly: "",
  wakeUpSeveralTimes: "",
  poorSleep: "",
};
